<template>
  <div>
    <div v-if="!$store.state.global.manufacturer" class="text-center">
      <b-spinner></b-spinner>
    </div>
    <div v-if="$store.state.global.manufacturer">
      <app-header
        :title="$store.state.global.manufacturer.name"
        :subtitle="'Manufacturer #'+ $store.state.global.manufacturer.id"
      >
        <b-button v-router-link="{ name:'manufacturer-editor', query: { id: $route.params.id }}" variant="primary">
          <i class="fa fa-pencil-square-o" style="font-size:20px" /> Edit Manufacturer
        </b-button>
      </app-header>
      <b-container>
        <b-nav tabs class="mb-3">
          <b-nav-item :to="{ name: 'manufacturer-profile-tab' }">
              Profile
          </b-nav-item>
          <b-nav-item v-if="$store.state.global.devices" :to="{ name: 'manufacturer-devices-tab' }">
              ({{ $store.state.global.devices.length }}) Devices
          </b-nav-item>
        </b-nav>
        <div>
          <router-view />
        </div>
      </b-container>
    </div>
  </div>
</template>

<script>
import $api from '@/services/api';
import AppHeader from '@/components/AppHeader';

export default {
  name: 'ManufacturerDetail',

  components: {
    AppHeader,
  },

  created() {
    this.$store.commit('global/clearAll');
    this.refreshData();
  },

  methods: {
    async refreshData() {
      const manufacturerId = this.$route.params.id;

      const manufacturer = await $api.get(`/v1/internal/manufacturers/${manufacturerId}`);
      this.$store.commit('global/setManufacturer', manufacturer);

      const devices = await $api.get(`/v1/internal/devices?manufacturer_id=${manufacturerId}`);
      this.$store.commit('global/setDevices', devices);
    },
  },
};
</script>
